/* eslint-disable sort-imports */
import '@config';
import './vendor/bootstrap.js';
import '@styles/theme';
import './images';
import Router from './components/router';
import LoadMore from './components/loadMore';
import PostsSlider from './components/postsSlider';
import FormMailchimp from './components/formMailchimp';
import ClientsSlider from './components/clientsSlider';
import ImageCarousel from './blocks/imageCarousel';
import FancyClientList from './blocks/fancyClientList';
import SingleHero from './blocks/singleHero';
import SingleEntry from './components/singleEntry';
import LottieAnimation from './components/lottieAnimation';
// import Table from './components/table';
import './directives/vimeo';
import './legacy';

$(document).ready(() => {
  const router = new Router([
    new ImageCarousel(),
    new LoadMore(),
    new FancyClientList(),
    new FormMailchimp(),
    new PostsSlider(),
    new SingleHero(),
    new ClientsSlider(),
    new SingleEntry(),
    new PostsSlider(),
    new LottieAnimation(),
    // new Table(),
  ]);

  router.bootstrap();
});
